import fp from 'lodash/fp';

export const adventuresByIdSelector = fp.compose(fp.get('AdventuresID.data.adventure'));
export const adventureIdSelector = fp.compose(fp.get('AdventuresID.id'));
